import {_serializeSingle, _serializeList} from './core';
import {serializeMemberBff} from './member';

import type {ServerData} from './core';
import type {DomainOf} from '../../../types/domain';

// Workspace
export function serializeWorkspace(data: ServerData) {
    return _serializeSingle("workspace", data);
}

export function serializeWorkspaceList(data: ServerData) {
    return _serializeList("workspace", data);
}

// Workspace API Key
export function serializeWorkspaceApiKey(data: ServerData) {
    return _serializeSingle("workspaceApiKey", data);
}

export function serializeWorkspaceApiKeyList(data: ServerData) {
    return _serializeList("workspaceApiKey", data);
}

// Workspace Data
export function serializeWorkspaceData(data: ServerData) {
    return _serializeSingle("workspaceData", data);
}

export function serializeWorkspaceDataList(data: ServerData) {
    return _serializeList("workspaceData", data);
}

// Workspace Config
export function serializeWorkspaceConfig(data: ServerData) {
    return _serializeSingle("workspaceConfig", data);
}

export function serializeWorkspaceConfigList(data: ServerData) {
    return _serializeList("workspaceConfig", data);
}

// External API Log
export function serializeExternalApiLog(data: ServerData) {
    return _serializeSingle("externalApiLog", data);
}

export function serializeExternalApiLogList(data: ServerData) {
    return _serializeList("externalApiLog", data);
}

// System Status
export function serializeSystemStatus(data: ServerData) {
    return _serializeSingle("systemStatus", data);
}

// System Workspace BFF
/** 워크스페이스 + 관리자 요약 */
export type SystemWorkspaceBff = DomainOf<"workspace"> & {
    "workspaceManager.id"?: string;
    "workspaceManager.name"?: string;
    "workspaceManager.email"?: string;
    "workspaceManager.authId"?: string;
};

export function serializeSystemWorkspaceBff(data: ServerData): Partial<SystemWorkspaceBff> {
    const workspace: Partial<SystemWorkspaceBff> = serializeWorkspace(data) || {};
    if (data?.workspaceAdminMember) {
        const admin: Partial<DomainOf<"member"> & DomainOf<"user">> = serializeMemberBff(data.workspaceAdminMember) || {};
        workspace['workspaceManager.id'] = admin['user.id'] || '';
        workspace['workspaceManager.name'] = admin['member.name'] || '';
        workspace['workspaceManager.email'] = admin['member.email'] || '';
        workspace['workspaceManager.authId'] = admin['user.authId'] || '';
    }
    return workspace;
}
